var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('action-button',{attrs:{"title":_vm.title,"disabled":_vm.disabled,"icon":_vm.$icons.external_link},on:{"action":_vm.open}})}
var staticRenderFns = []

export { render, staticRenderFns }